import { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Spin } from 'antd'
import { setShowPopupMarkerId } from '@/store/slice/marker'
import InfiniteScroll from 'react-infinite-scroll-component'
import StoreListItem from '@components/StoreListItem'
import * as Gmap from '@/modules/googlemap'
import * as Status from '@data/status.js'

const UNIT = 10

const StoreList = (props) => {
  const dispatch = useDispatch()
  const { stores, wrapperId } = props
  const status = useSelector((state) => state.data.status)
  const [count, setCount] = useState(UNIT)
  const [storeBucket, setStoreBucket] = useState([])
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    // init storeBucket when stores data loaded
    if (stores.length > 0 && status === Status.SUCCESS) {
      setStoreBucket(stores.slice(0, UNIT))
    }
  }, [status, stores])

  const loadStores = useCallback(() => {
    if (stores.length === storeBucket.length) {
      setHasMore(false)
      return
    }
    const num = count + UNIT
    setStoreBucket(stores.slice(0, num))
    setCount(num)
  }, [stores, storeBucket, count])

  // TODO: be react hook
  const onStoreClick = useCallback((store) => {
    const { lat, lng } = store.latlng
    Gmap.panTo(lat, lng)
    dispatch(setShowPopupMarkerId(store.storeid))
  }, [dispatch])

  if (status !== Status.SUCCESS) return null

  return (
    <InfiniteScroll
      dataLength={storeBucket.length}
      next={loadStores}
      hasMore={hasMore}
      scrollableTarget={wrapperId}
      loader={
        <div className="text-center">
          <Spin />
        </div>
      }
      endMessage={
        <p className="text-center">
          <b>已經滑到底囉</b>
        </p>
      }
    >
      {storeBucket.map(store => 
        <StoreListItem key={store.storeid} store={store} onClick={onStoreClick} />)
      }
    </InfiniteScroll>
  )
}

export default StoreList